import { useEffect } from 'react'
import { useQuery } from '@tanstack/react-query'
import { useToast } from '@/view/components/ui/use-toast'
import { crefazService } from '../services/crefazService'

export const useRelationshipDegree = () => {
  const { isError, isFetching, isLoading, data } = useQuery({
    queryKey: ['relationshipDegree'],
    queryFn: crefazService.getRelationshipDegree,
  })

  const { toast } = useToast()

  useEffect(() => {
    if (isError) {
      toast({
        variant: 'destructive',
        title:
          'Erro ao carregar o grau de parentesco, tente novamente mais tarde!',
      })
    }
  }, [isError, toast])

  return {
    isFetching,
    isLoading,
    data,
  }
}
